export default "__VITE_ASSET__DHiqAD9z__"